const currentRoles = state => state.views[state.orgId]?.roles

export const mutations = {
  SET_ORG(state, orgId) {
    state.orgId = orgId
  },
  SET_VIEW(state, { orgId, view }) {
    state.views = { ...state.views, [orgId]: view }
  },
  SET_ROLE(state, role) {
    const roles = currentRoles(state)
    if (!roles) return
    const index = roles.findIndex(r => r.role_id === role.role_id)
    if (index === -1) roles.push(role)
    else roles.splice(index, 1, role)
  },
  REMOVE_ROLE(state, roleId) {
    const roles = currentRoles(state)
    const index = roles?.findIndex(r => r.role_id === roleId) ?? -1
    if (index !== -1) roles.splice(index, 1)
  },
  SET_DEFAULT_JOIN(state, role) {
    currentRoles(state)
      ?.filter(r => r.kind === role.kind)
      .forEach(r => { r.is_default_join = r.role_id === role.role_id })
  },
}
